import {pageInfo, initUpdate, coalTransportVehicleClose, getCoalPlanSearch, addData} from "../api";
const coalPlanTransportVehicle = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    closeResp: null,
    coalPlanTotal: null,
    coalPlanResp: null,
    addSubmitResp:null,
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj.map(item=>({...item, btns:[true,item.transportStatusCode == '99' ? false : true]})) || [];
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data.obj;
    },
    CLOSE_DATA(state, data){
      state.closeResp = data;
    },
    ADD_DATA(state, data){
      state.addSubmitResp = data;
    },
    COAL_PLAN_PAGEINFO(state, data){
      state.coalPlanTotal = data.total;
      state.coalPlanResp = data.obj || [];
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //关闭
    async coalTransportVehicleClose({ commit }, obj) {
      let resp = await coalTransportVehicleClose(obj);
      commit('CLOSE_DATA', resp);
    },
    //新增提交
    async addSubmit({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //查询外采计划单
    async getCoalPlanSearch({ commit }, obj) {
      let resp = await getCoalPlanSearch(obj);
      commit('COAL_PLAN_PAGEINFO', resp);
    },
  }
}
export default coalPlanTransportVehicle



// WEBPACK FOOTER //
// ./src/page/bd/coal/coalPlanTransportVehicle/store/coalPlanTransportVehicle.store.js